import { UserMap } from '@lowcodeunit/lcu-map-common';

export class ThumbnailListModel{
    public Map: UserMap;
    public MapUrl: string;
    public Title: string;
    public Lat: number | string;
    public Lng: number | string;

    /**
     * 
     * @MapUrl the url to into img src
     * 
     * @title the name of the location
     * 
     * @lat the latitude of the location
     * 
     * @lng the longitude of the location
     * 
     */

     constructor(map: UserMap, mapUrl:string, title:string, lat:number|string, lng: number|string){
        this.Map = map;
        this.MapUrl = mapUrl; 
        this.Title = title;
        this.Lat = lat;
        this.Lng = lng;
     }
}